import React from "react";
import { NavLink } from "react-router-dom";
import { Phone, Users, CheckSquare, Zap, Columns3, LayoutDashboard, Settings, LogOut, Video, Handshake, PhoneForwarded, AlertTriangle, Inbox, PhoneCall, Eye, Flame } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuthStore } from "@/stores/authStore";
import { UserAvatar } from "@/components/shared/Badges";
import { ROLE_LABELS } from "@/utils/formatters";

const NAV = [
  { to: "/call", label: "Rychlé volání", icon: Phone },
  { to: "/tasks/quick", label: "Rychlé úkoly", icon: Zap },
  { to: "/contacts", label: "Kontakty", icon: Users },
  { to: "/tasks", label: "Úkoly", icon: CheckSquare },
  { to: "/pipeline", label: "Pipeline", icon: Columns3 },
  { to: "/inbox", label: "E-maily", icon: Inbox },
  { to: "/calls", label: "Hovory", icon: PhoneCall },
  { to: "/webinars", label: "Webináře / Leady", icon: Video },
  { to: "/hot", label: "Horké kontakty", icon: Flame },
  { to: "/deals", label: "Dealy", icon: Handshake },
  { to: "/callbacks", label: "Zpětná volání", icon: PhoneForwarded },
  { to: "/quality", label: "Kvalita dat", icon: AlertTriangle },
  { to: "/review", label: "Kontrola", icon: Eye, admin: true },
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin", label: "Administrace", icon: Settings, admin: true },
];

export const Sidebar = () => {
  const { user, logout } = useAuthStore();
  return (
    <aside className="flex h-screen w-60 shrink-0 flex-col border-r border-gray-200 bg-white" data-testid="sidebar">
      <div className="flex h-16 items-center gap-3 px-5">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-700 text-lg font-bold text-white">M</span>
        <span className="text-lg font-bold tracking-tight text-gray-900">Machna CRM</span>
      </div>
      <nav className="mt-1 min-h-0 flex-1 space-y-0.5 overflow-y-auto px-3 pb-2">
        {NAV.filter((n) => !n.admin || user?.role === "admin").map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === "/tasks"} data-testid={`nav-${to.slice(1).replace("/", "-")}`}
            className={({ isActive }) => cn("flex items-center gap-3 rounded-lg px-3 py-2 text-base", isActive ? "bg-brand-50 font-semibold text-brand-800" : "text-gray-700 hover:bg-gray-100")}>
            <Icon className="h-5 w-5 shrink-0" />{label}
          </NavLink>))}
      </nav>
      <div className="shrink-0 border-t border-gray-200 p-3" data-testid="sidebar-user">
        <div className="flex items-center gap-3 px-1">
          <UserAvatar name={user?.full_name} size={9} />
          <div className="min-w-0 flex-1"><p className="truncate text-base font-semibold text-gray-900">{user?.full_name}</p><p className="truncate text-sm text-gray-500">{ROLE_LABELS[user?.role]}</p></div>
        </div>
        <button onClick={logout} data-testid="logout-btn" className="mt-2 flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-base font-medium text-gray-700 hover:border-red-200 hover:bg-red-50 hover:text-red-700"><LogOut className="h-5 w-5" />Odhlásit se</button>
      </div>
    </aside>
  );
};
